export default __webpack_public_path__ + "static/dinoalastorres-79b4ce671407e57771cb2de32869525a.png";